import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
};

const refundsSlice = createSlice({
  name: 'refunds',
  initialState,
  reducers: {
    cancelRefundRequest(state) {
      state.loading = true;
      state.error = null;
    },
    cancelRefundSuccess(state, action) {
      state.loading = false;
      state.error = null;
      state.isRefundCancelled = true;
    },
    cancelRefundFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { cancelRefundRequest, cancelRefundSuccess, cancelRefundFailure } = refundsSlice.actions;

export default refundsSlice.reducer;
